/**
 * Created with JetBrains WebStorm.
 * User: yujy
 * Date: 16-03-29
 * Time: 上午10:41
 * To change this template use File | Settings | File Templates.
 */
import script from "./fvRenderScript";
export default class fvRenderContract {
    constructor(renderConfig){
        this.rd = renderConfig;
        this.m_fRotate = 3.1415926/180.00013* parseFloat(this.rd.rotate); //跟draw的精度一样
        if(this.rd.color){
            this.colorNum = this.rd.color.length;
        }

        this.oldrect="";
        this.m_pPotPtr=[];
        this.m_nPotNum=0;
        this.color=[];
        this.m_color=[];
        this.m_FRotate=0;
        this.m_RendCenter=0;  //收缩的中心
        this.m_ShapeUse=0;   //判断过以后的图形形状
        this.m_color=[];
        this.renderScript = new script();
    }

    rend(canvas, rect,obj) {
        if(obj==undefined){
            console.warn("渲染对象不能为空");
            return;
        }
        this.m_color = this.rd.color.slice();
        var colorNum = {value:this.colorNum};
        this.m_ShapeUse = this.rd.rendShape;
        this.m_RendCenter = this.rd.centerPos;
        this.m_FRotate = this.rd.rotate/3.1415926;
        var fRotate = parseFloat(this.m_fRotate) + parseFloat(this.rd.rotate);
        var color = new Array(10);
        this.renderScript.InitColor(color,colorNum,this.rd.colorGrade,this.rd.color.slice());	//初始化颜色
        var nPotNum = new Object();
        var pPot = new Array();
        this.GetPotArr(pPot,nPotNum,rect);//分配内存并初始化
        this.ZoomOutShape(pPot,nPotNum.value,rect);//拉伸形状
        if(this.oldrect!=rect){
            this.oldrect=rect;
            this.nSplit = this.ComputeSplit(rect,this.rd.grade,pPot);
        }
        this.CompletePoly(pPot,nPotNum,rect,this.nSplit,this.rd.grade);//完成多边形
        if(Math.abs(this.rd.rotate) > 0.000001)
            fRotate += this.rd.rotate;
        this.RotateShape(pPot,nPotNum.value,rect,fRotate);	//旋转形状
        var pAddXY = this.fcPaddArray(nPotNum.value,2);//[..][0]保存X,[..][1]保存Y
        var pAddAllXY= this.fcPaddArray(nPotNum.value,2);//已经增加的量
        this.MakeAddXY(pPot,nPotNum.value,rect,this.nSplit,pAddXY);
        var poldPot = new Array(nPotNum.value);
        for(var i=0; i<nPotNum.value; i++)
        {//备份多边形点信息
            poldPot[i] = {
                x:pPot[i].x,
                y:pPot[i].y
            }
            pAddAllXY[i][0] = pAddXY[i][0];
            pAddAllXY[i][1] = pAddXY[i][1];
        }
        //开始绘图
        var fr,fg,fb,frAdd,fgAdd,fbAdd;
        var colc = 0;
        var oldcolc = -1;
        var tempPolyNum = {
            value:nPotNum.value
        };
        var ptempPot =  [];
        this.fcInitArray(ptempPot,nPotNum.value*2,this.CPoint);
        var ptempPot2 = [];
        this.fcInitArray(ptempPot2,nPotNum.value*2,this.CPoint);
        //第二种
        for (var i = 0; i <= this.nSplit; i++) {
            colc = parseInt(i * (colorNum.value - 1) / this.nSplit);
            if (colc != oldcolc) {//这里没有使用双重循环，那样会出现误差
                var rgbArray = color[colc].colorRgb();
                fr = rgbArray[0];
                fg = rgbArray[1];
                fb = rgbArray[2];
                if(color[colc+1] != undefined){
                    var rgbArray1 = color[colc+1].colorRgb();
                }
                frAdd = parseFloat((rgbArray1[0] - fr) / (parseFloat(this.nSplit - 1) / (colorNum.value - 1)));
                fgAdd = parseFloat((rgbArray1[1] - fg) / (parseFloat(this.nSplit - 1) / (colorNum.value - 1)));
                fbAdd = parseFloat((rgbArray1[2] - fb) / (parseFloat(this.nSplit - 1) / (colorNum.value - 1)));
                oldcolc = colc;
            }
            var tempRGB = "RGB("+fr+","+fg+","+fb+")";
            var tempColor = tempRGB.colorHex();
            tempPolyNum.value = nPotNum.value;
            this.ClipPoly(pPot,ptempPot,ptempPot2,tempPolyNum,rect);
            canvas.beginPath();
            canvas.fillStyle = tempColor;
            canvas.lineWidth = 1;
            canvas.strokeStyle = tempColor;
            canvas.moveTo(parseFloat(ptempPot[0].x),parseFloat(ptempPot[0].y));
            for(var i_cur = 1 ;i_cur < nPotNum.value ; i_cur++) {
                if((parseInt(ptempPot[i_cur].x) ===  parseInt(ptempPot[i_cur].y))
                    &&(parseInt(ptempPot[i_cur].x) === 0)){
                    continue;
                }
                canvas.lineTo(parseInt(ptempPot[i_cur].x), parseInt(ptempPot[i_cur].y));
            }
            canvas.closePath();
            canvas.stroke();
            canvas.fill();
            if(i < this.nSplit)
            {
                for(var k = 0; k<nPotNum.value; k++)
                {
                    pPot[k].x = poldPot[k].x + parseInt(pAddAllXY[k][0]);
                    pPot[k].y = poldPot[k].y + parseInt(pAddAllXY[k][1]);
                    pAddAllXY[k][0] += pAddXY[k][0];
                    pAddAllXY[k][1] += pAddXY[k][1];
                }
            }
            fr += frAdd;
            fg += fgAdd;
            fb += fbAdd;
        }
    }

    GetPotArr(pPot,PotNum,rect) {
        //分配内存，并顺时针设置外圈数据
        var nRX = parseFloat(rect.width);
        var nRY = parseFloat(rect.height);
        var fCirA = 0,fCirB = 0;//为外接椭圆的a,b轴
        var nCenX = parseFloat(rect.left) + parseFloat(nRX/2.0);//nRX,nRY为中心坐标
        var nCenY = parseFloat(rect.top) + parseFloat(nRY/2.0);
        var len = Math.sqrt(parseFloat(nRX*nRX+nRY*nRY));//矩形对角线
        var nSideNum = 4;
        switch(this.m_ShapeUse)
        {
            case 0:
                this.fcInitArray(pPot,10,this.CPoint);
                PotNum.value = 5;		//表示只初始化了5个点
                if(nRX > nRY)
                {
                    pPot[0] ={
                        x:rect.left,
                        y:rect.top - parseFloat(4)
                    };
                    pPot[1] ={
                        x:rect.right,
                        y:rect.top - parseFloat(4)
                    };
                    pPot[2] ={
                        x:rect.right,
                        y:rect.bottom + parseFloat(4)
                    };
                    pPot[3] ={
                        x:rect.left,
                        y:rect.bottom + parseFloat(4)
                    };
                    pPot[4] = {
                        x:pPot[0].x,
                        y:pPot[0].y
                    };
                }
                else
                {
                    pPot[0] ={
                        x:rect.left - parseFloat(4),
                        y:rect.top
                    };
                    pPot[1] ={
                        x:rect.right + parseFloat(4),
                        y:rect.top
                    };
                    pPot[2] ={
                        x:rect.right + parseFloat(4),
                        y:rect.bottom
                    };
                    pPot[3] ={
                        x:rect.left - parseFloat(4),
                        y:rect.bottom
                    };
                    pPot[4] = {
                        x:pPot[0].x,
                        y:pPot[0].y
                    };
                }
                return;
                break;
            case 2:
                nSideNum = 4;
                this.fcInitArray(pPot,10,this.CPoint);
                PotNum.value = 5;		//表示只初始化了5个点
                fCirA = fCirB = 1.41421356*len/1.9;
                break;
            case 1:
                nSideNum = 3;
                this.fcInitArray(pPot,8,this.CPoint);
                PotNum.value = 4;		//表示只初始化了5个点
                fCirA = fCirB = len*2.0/1.9;
                break;
            case 3:
                nSideNum = 5;
                this.fcInitArray(pPot,12,this.CPoint);
                PotNum.value = 6;		//表示只初始化了5个点
                fCirA = fCirB = (len/1.9)/parseFloat(Math.cos(3.1415926/5.0));
                break;
            case 4:
                nSideNum = 6;
                this.fcInitArray(pPot,14,this.CPoint);
                PotNum.value = 7;
                fCirA = fCirB = (len/1.9)/parseFloat(Math.cos(3.1415926/6.0));
                break;
            case 5:
                nSideNum = 40;
                this.fcInitArray(pPot,82,this.CPoint);
                PotNum.value = 41;
                fCirA = fCirB = (len/1.9)/parseFloat(Math.cos(3.1415926/40.0));
                break;
            case 6:
            {
                nSideNum = 40;
                this.fcInitArray(pPot,82,this.CPoint);
                PotNum.value = 41;
                var rotate = this.m_FRotate;//收缩

                var tempObj = {
                    value: rotate
                }
                this.renderScript.RotateTo2Pi(tempObj);
                rotate = tempObj.value;
                var fsin = parseFloat(Math.sin(rotate));
                var fcos = parseFloat(Math.cos(rotate));
                var ftempRat;
                if(nRX == 0 || nRY == 0)
                    ftempRat = 0;
                else
                {
                    var t1,t2,t3;
                    t1 = 2.0*parseFloat(fcos*fcos);
                    t2 = 2.0*(parseFloat(nRY)/(nRX)-parseFloat(nRX)/(nRY))*fsin*fcos;
                    t3 = parseFloat((nRY*nRY)/(nRX*nRX)+(nRX*nRX)/(nRY*nRY))*fsin*fsin;
                    var nQ = parseFloat(rotate*2.0/3.1415926);
                    if(nRX > nRY)
                    {
                        if(nQ)
                            ftempRat = Math.sqrt(parseFloat(t1 + t2 + t3));
                        else
                            ftempRat = Math.sqrt(parseFloat(t1 - t2 + t3));
                    }
                    else
                    {
                        if(nQ)
                            ftempRat = Math.sqrt(parseFloat(t1 - t2 + t3));
                        else
                            ftempRat = Math.sqrt(parseFloat(t1 + t2 + t3));
                    }
                }
                fCirA = parseFloat(nRX+1);
                fCirB = parseFloat(nRY+1);
                if(fCirA > 10.0*fCirB)
                    fCirB = fCirA/10.0;
                else if(fCirB > 10.0*fCirA)
                    fCirA = fCirB/10.0;
                fCirA = fCirA*parseFloat(ftempRat/1.9);
                fCirB = fCirB*parseFloat(ftempRat/1.9);
            }
                break;
            default:
                break;
        }
        var ratadd = parseFloat(3.1415926*2.0/nSideNum);
        var ratall = 0.0;
        for(var i=0; i<nSideNum; i++)
        {
            pPot[i].x = parseInt(nCenX + fCirA*Math.cos(ratall)+0.5);
            pPot[i].y = parseInt(nCenY + fCirB*Math.sin(ratall)+0.5);
            ratall += ratadd;
        }
        pPot[nSideNum] = {
            x:pPot[0].x,
            y:pPot[0].y
        };
    }

    ZoomOutShape(pPot,PotNum,rect) {
        var fRat;
        var nRw = rect.width;
        var nRh = rect.height;
        var len;
        var fr;
        var max;
        var min;
        var fr2pi;
        var fsplit2pi;
        switch(this.m_ShapeUse)
        {
            case 0:
                if(nRw == 0 || nRh == 0)
                    return;
                max = nRw>nRh?nRw:nRh;
                min = nRw>nRh?nRh:nRw;
                len = Math.sqrt(parseFloat(nRw*nRw)+parseFloat(nRh*nRh));
                fr = Math.asin(max/len);
            {
                var f2pi = this.m_FRotate;
                var tempObj = {value:f2pi};
                this.renderScript.RotateTo2Pi(tempObj);
                f2pi = tempObj.value;
                fr2pi = f2pi;
            }
                fsplit2pi = parseFloat(3.1415926/2.0);
                if(fr2pi < fsplit2pi || (fr2pi>3.1415926 && fr2pi<fsplit2pi*3))
                {
                    fr = fr2pi - fr;
                    fRat = parseFloat(Math.abs(len*Math.cos(fr)/min)*1.1);
                }
                else
                {
                    fr = fr2pi+fr-fsplit2pi;
                    fRat = parseFloat(Math.abs(len*Math.sin(fr)/min)*1.1);
                }
                if(fRat < 1.1)
                    fRat = 1.1;
                break;
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                return;
                break;
        }
        var centx = rect.left + rect.width/2.0;
        var centy = rect.top + rect.height/2.0;
        for(var i=0; i<PotNum; i++){
            this.ZoomOutOnePot((pPot[i]),centx,centy,fRat);
        }
    }

    CompletePoly(pPot,nPotNum,rect,nSplit,grade) {
        nPotNum.value += nPotNum.value;
        for(var i=0; i<nPotNum.value/2 ;i++)
        {
            pPot[parseInt(nPotNum.value-1-i)].x = pPot[i].x;
            pPot[parseInt(nPotNum.value-1-i)].y = pPot[i].y;
        }
        var rW = rect.width;
        var rH = rect.height;
        var fRat;
        var len = Math.sqrt(parseFloat(parseFloat(rW*rW + rH*rH)));
        var flitte = 2.0;
        switch(grade)
        {
            case 0:
                flitte = 1.3;
                break;
            case 1:
                flitte = 1.4;
                break;
            case 2:
                flitte = 1.7;
                break;
            case 3:
                flitte = 2.3;
                break;
            case 4:
                flitte = 3.0;
                break;
            default:
            //ASSERT(0);//未知类型
        }
        if(this.m_RendCenter == 0)
            fRat = parseFloat(1.0) - parseFloat(flitte/nSplit);//1.6f/nSplit;
        else
            fRat = parseFloat(1.0) - parseFloat(flitte*2.0/nSplit);//3.0f/nSplit;//保证不出现空洞所以用3.0f/nSplit
        fRat = fRat<0?0:fRat;
        var centx = rect.left + parseFloat(rW/2.0);
        var centy = rect.top + parseFloat(rH/2.0);
        for(var i=nPotNum.value/2; i<nPotNum.value; i++)
            this.ZoomOutOnePot((pPot[i]),centx,centy,fRat);
        if(this.m_ShapeUse == 0)
        {
            pPot[0].x -= 1;
            pPot[0].y -= 1;
            pPot[1].x += 1;
            pPot[1].y -= 1;
            pPot[2].x += 1;
            pPot[2].y += 1;
            pPot[3].x -= 1;
            pPot[3].y += 1;
            pPot[4].x = pPot[0].x;
            pPot[4].y = pPot[0].y;
        }
    }

    RotateShape(pPot,PotNum,rect,fRotate) {
        var centx = rect.left + rect.width/2.0;
        var centy = rect.top + rect.height/2.0;
        var dbsin = Math.sin(fRotate);
        var dbcos = Math.cos(fRotate);
        for(var i=0; i<PotNum; i++)
            this.RotateOnePot((pPot[i]),centx,centy,dbsin,dbcos);
    }

    MakeAddXY(pPot,nPotNum,rect,nSplit,pAddXY) {
        var fPCenX;
        var fPCenY;
        var fHalfX = rect.width/2.0;
        var fHalfY = rect.height/2.0;
        switch(this.m_RendCenter)
        {
            case 0:
                fPCenX = rect.left + fHalfX;
                fPCenY = rect.top + fHalfY;
                break;
            case 1:
                fPCenX = rect.left;
                fPCenY = rect.top;
                break;
            case 2:
                fPCenX = rect.right;
                fPCenY = rect.top;
                break;
            case 3:
                fPCenX = rect.left;
                fPCenY = rect.bottom;
                break;
            case 4:
                fPCenX = rect.right;
                fPCenY = rect.bottom;
                break;
            case 5:
                fPCenX = rect.left;
                fPCenY = rect.top + parseFloat(fHalfY);
                break;
            case 7://右中
                fPCenX = rect.right;
                fPCenY = rect.top + parseFloat(fHalfY);
                break;
            case 6://上中
                fPCenX = rect.left + parseFloat(fHalfX);
                fPCenY = rect.top;
                break;
            case 8://下中
                fPCenX = rect.left + parseFloat(fHalfX);
                fPCenY = rect.bottom;
                break;
        }
        var halfNum = parseFloat(nPotNum/2);
        var ftemp;
        for(var i=0; i<halfNum; i++)
        {
            ftemp = parseFloat(fPCenX - pPot[halfNum+i].x)/(nSplit);
            pAddXY[halfNum-i-1][0] = pAddXY[halfNum+i][0] = ftemp;
            ftemp = parseFloat(fPCenY - pPot[halfNum+i].y)/(nSplit);
            pAddXY[halfNum-i-1][1] = pAddXY[halfNum+i][1] = ftemp;
        }
    }

    ComputeSplit(rect,grade,pPot) {
        var centx = rect.left + parseFloat(rect.width/2.0);
        var centy = rect.top + parseFloat(rect.height/2.0);
        var all;

        if(this.m_ShapeUse == 0)
        {
            var cent12x = parseFloat((pPot[0].x + pPot[1].x));
            var cent12y = parseFloat((pPot[0].y + pPot[1].y));
            var cent23x = parseFloat((pPot[1].x + pPot[2].x));
            var cent23y = parseFloat((pPot[1].y + pPot[2].y));
            var all12 = parseFloat((cent12x-centx)*(cent12x-centx)+(cent12y-centy)*(cent12y-centy));
            var all23 = parseFloat((cent23x-centx)*(cent23x-centx)+(cent23y-centy)*(cent23y-centy));
            if(all12>all23)
                all = Math.sqrt(parseInt(all23));
            else
                all = Math.sqrt(parseInt(all12));
        }
        else if(this.m_ShapeUse == 6)
        {
            var cent12x = parseFloat(pPot[0].x);
            var cent12y = parseFloat(pPot[0].y);
            var cent23x = parseFloat(pPot[10].x);
            var cent23y = parseFloat(pPot[10].y);
            var all12 = parseFloat((cent12x-centx)*(cent12x-centx)+(cent12y-centy)*(cent12y-centy));
            var all23 = parseFloat((cent23x-centx)*(cent23x-centx)+(cent23y-centy)*(cent23y-centy));
            if(all12>all23)
                all = Math.sqrt(parseInt(all23));
            else
                all = Math.sqrt(parseInt(all12));
        }
        else
            all = rect.width>rect.height? rect.width: rect.height;
        if(this.m_RendCenter == 0)
        {
            all = all/2;
        }
        return this.renderScript.Split(all,grade);
    }

    ZoomOutOnePot(pPot,centx,centy,fRate) {
        var tempx = parseFloat(pPot.x - centx);
        var tempy = parseFloat(pPot.y - centy);
        pPot.x = parseFloat(tempx * fRate + centx+0.5);
        pPot.y = parseFloat(tempy * fRate + centy+0.5);
    }

    RotateOnePot(pPot,centx,centy,dbsin,dbcos) {
        var tempx = parseFloat(pPot.x - centx);
        var tempy = parseFloat(pPot.y - centy);
        pPot.x = parseInt(tempx * dbcos - tempy * dbsin+0.5 + centx);
        pPot.y = parseInt(tempx * dbsin + tempy * dbcos+0.5 + centy);
    }

    ClipPoly(pot,tempPot1,tempPot2,pnPoltPot,rect) {
        var edge = rect.left;
        this.ClipOneSide(parseFloat(edge),0,pot,tempPot2,pnPoltPot);//左
        edge = rect.top;
        this.ClipOneSide(parseFloat(edge),1,tempPot2,tempPot1,pnPoltPot);//上
        edge = rect.right;
        this.ClipOneSide(parseFloat(edge),2,tempPot1,tempPot2,pnPoltPot);//右
        edge = rect.bottom;
        this.ClipOneSide(parseFloat(edge),3,tempPot2,tempPot1,pnPoltPot);//下
    }

    ClipOneSide(edge,type,pPtin,pPtOut,pnNum) {
        var num = pnNum.value;
        var NumOut = {value:0};
        var pPt1 = pPtin[num-1];
        for(var i=0; i<num; i++)
        {
            this.ClipTest(edge,type,pPt1,pPtin[i],pPtOut,NumOut);
            pPt1 = pPtin[i];
        }
        pnNum.value = NumOut.value;
    }

    ClipTest(edge,type,pPot1,pPot2,pPotOut,pnNum) {
        if(pnNum.value >= 8){
            var a = 0;
        }
        var bIsin = false;
        var bTwoside = false;
        switch(type)
        {
            case 0://左边
                if(pPot2.x >= edge)
                {
                    bIsin = true;
                    if(pPot1.x < edge)
                        bTwoside = true;
                }
                else if(pPot1.x >= edge)
                    bTwoside = true;
                break;
            case 1://上边
                if(pPot2.y >= edge)
                {
                    bIsin = true;
                    if(pPot1.y < edge)
                        bTwoside = true;
                }
                else if(pPot1.y >= edge)
                    bTwoside = true;
                break;
            case 2://右边
                if(pPot2.x <= edge)
                {
                    bIsin = true;
                    if(pPot1.x > edge)
                        bTwoside = true;
                }
                else if(pPot1.x <= edge)
                    bTwoside = true;
                break;
            case 3://下边
                if(pPot2.y <= edge)
                {
                    bIsin = true;
                    if(pPot1.y > edge)
                        bTwoside = true;
                }
                else if(pPot1.y <= edge)
                    bTwoside = true;
                break;
            default:
                //ASSERT(0);//其他类型
                break;
        }
        if(bTwoside)
        {
            var fk;
            if(pPot1.x == pPot2.x)
            {
                pPotOut[pnNum.value].y = edge;
                pPotOut[pnNum.value].x = pPot2.x;
                pnNum.value++;
            }
            else
            {
                fk = parseFloat(pPot2.y - pPot1.y)/(pPot2.x - pPot1.x);
                if(type == 0 || type == 2)
                {
                    pPotOut[pnNum.value].x = edge;
                    pPotOut[pnNum.value].y = parseFloat(pPot1.y+(pPotOut[pnNum.value].x - pPot1.x)*fk+0.5);
                    pnNum.value++;
                }
                else
                {
                    pPotOut[pnNum.value].y = edge ;
                    pPotOut[pnNum.value].x = parseFloat(pPot1.x+(pPotOut[pnNum.value].y - pPot1.y)/fk+0.5);
                    pnNum.value++;
                }
            }
        }
        if(bIsin)
        {
            pPotOut[pnNum.value].x = pPot2.x;
            pPotOut[pnNum.value].y = pPot2.y;
            pnNum.value++;
        }
    }
    fcInitArray(arr,num,ObjFunc){
        for(var i = 0; i < num; i++) {
            arr.push(ObjFunc());
        }
    }
    CPoint(){
        return {
            x:0,
            y:0
        }
    }
    fcPaddArray(num1,num2,ObjFunc){
        if(!ObjFunc){
            ObjFunc = function(){
                return 0;
            }
        }
        var tArray = new Array();
        for(var k = 0; k < num1; k++){
            tArray[k] = new Array();
            for(var j = 0;j < num2; j++){
                tArray[k][j] = ObjFunc();
            }
        }
        return tArray;
    }
}


// WEBPACK FOOTER //
// ./src/js/render/fvRenderContract.js